import { PiCertificateBold } from "react-icons/pi";
import { CERTIFICATES } from "../../data/resumeData";

function Certificates() {
    return (
      <section className="certificates fade-in">
        <h2>Certificates and Continued Learning</h2>
          {CERTIFICATES.map((certificateItem, index) => (
            <div key={index}>
              <div className="container">
                <div className="heading-4">
                  { certificateItem.certification && <PiCertificateBold title="Certificate" /> }
                  {certificateItem.topic}
                </div>
                
                <div className="date">
                  <span>{certificateItem.sponsor}</span>
                </div>
              </div>
            </div>
          ))}
      </section>
    );
  }
  
export default Certificates;